import React from "react";
import { Link } from "react-router-dom";
import placeImage from "../../images/placeholder.jpg";
import NoData from "../../Component/NoData";
import Dataloader from "../../Component/Dataloader";
import NumberFormatter from "../../Component/NumberFormatter";

export default function TransporterEnquiry({ enquiryList, dataLoading }) {
    const imageOnError = (event) => {
        event.currentTarget.src = placeImage;
    };

    return (
        <>
            {dataLoading ? (
                <div className="d-flex justify-content-center">
                    <Dataloader />
                </div>
            ) : (
                <>
                    {enquiryList.length > 0 ? (
                        <div className="row g-3">
                            {enquiryList.map((enquiry, index) => (
                                <div className="col-lg-6 px-2" key={index}>
                                    <div className="order-product">
                                        <div className="row align-items-center">
                                            <div className="col-3">
                                                <div className="order-image">
                                                    <img
                                                        src={enquiry.commodity_product.thumbnail}
                                                        onError={imageOnError}
                                                        alt="product"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-8 ps-0">
                                                <div className="order-detail">
                                                    <h6 className="one-line-clamp">
                                                        <span className="me-2">Quotation No:</span>
                                                        {enquiry.unique_id}
                                                    </h6>
                                                    <h6 className="one-line-clamp">
                                                        {enquiry.commodity_product.name}
                                                    </h6>
                                                    <div className="order-tag">
                                                        <div>
                                                            <span className="f-500">Max Price:</span>
                                                            <span>
                                                                Rs <NumberFormatter number={enquiry.max_price} />
                                                            </span>
                                                        </div>
                                                        <div>
                                                            <span className="f-500">Min Price:</span>
                                                            <span>
                                                                Rs <NumberFormatter number={enquiry.min_price} />
                                                            </span>
                                                        </div>
                                                        <div>
                                                            <span className="f-500">Origin City:</span>
                                                            <span>{enquiry.origin_city}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <h6
                                                className={`status ${enquiry.status === "pending" ? "pending" : "delivered"
                                                    }`}
                                            >
                                                {enquiry.status}
                                            </h6>
                                        </div>
                                        <div className="row order-product-btn">
                                            <div
                                                className="col-lg-12
                              d-flex justify-content-center"
                                            >
                                                <Link
                                                    to={`/transporter-product-enquiry-detail/${enquiry.id}`}
                                                    type="button"
                                                    className="ord-btn invc"
                                                    title="Order Detail"
                                                >
                                                    <i className="bi bi-basket2 me-1"></i>
                                                    View Details
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <NoData />
                    )}
                </>
            )}
        </>
    );
}
